/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('DinghyBookingDetailMember', DinghyBookingDetailMember);

    DinghyBookingDetailMember.$inject = ['$resource', 'DateUtils'];

    function DinghyBookingDetailMember ($resource, DateUtils) {
        var resourceUrl =  'api/member/dinghy-bookings/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fromDate = DateUtils.convertDateTimeFromServer(data.fromDate);
                        data.untilDate = DateUtils.convertDateTimeFromServer(data.untilDate);
                    }
                    return data;
                }
            }
        });
    }
})();
